var name = {};
module['exports'] = name;
name.male_prefix = require("./male_prefix");
name.male_first_name = require("./male_first_name");
name.female_prefix = require("./female_prefix");
name.female_first_name = require("./female_first_name");
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.prefix = require("./prefix");
name.suffix = require("./suffix");
name.name = require("./name");